export default __webpack_public_path__ + "static/media/pizzabhai-Logo.9975b4af.webp";